import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { SERVICE_AREAS, MAP_EMBED } from "@/lib/content";

export default function ServiceArea() {
  return (
    <section id="area" className="relative bg-[#0A0A0A] py-24 md:py-32 border-t border-white/10" data-testid="area-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
        >
          <p className="mb-6 text-xs uppercase tracking-mega text-gold">Where We Roam</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl text-white tracking-tight leading-[0.95]">
            Serving Utah's waters
          </h2>
          <p className="mt-6 max-w-md text-base md:text-lg font-light text-white/60 leading-relaxed">
            Based in Salt Lake City, we come to your marina, dock or driveway across the Wasatch Front
            and beyond.
          </p>
          <ul className="mt-10 grid grid-cols-2 gap-x-8 gap-y-4">
            {SERVICE_AREAS.map((a) => (
              <li key={a} className="flex items-center gap-3 text-white/75">
                <MapPin size={15} className="text-gold shrink-0" />
                <span className="text-sm">{a}</span>
              </li>
            ))}
          </ul>
          <p className="mt-10 text-sm text-white/40">
            Outside these waters? <span className="text-gold">Ask us</span> — we travel for the right vessel.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="relative aspect-[4/3] border border-gold/20 overflow-hidden"
        >
          <iframe
            title="Black Anchor Collective service area — Salt Lake City, Utah"
            src={MAP_EMBED}
            className="h-full w-full grayscale contrast-125 opacity-90"
            style={{ border: 0, filter: "grayscale(1) invert(0.9) contrast(0.9)" }}
            loading="lazy"
            data-testid="area-map"
          />
          <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-gold/20" />
        </motion.div>
      </div>
    </section>
  );
}
